import { PROJECT_NAME } from '@/config'
import { PERMISSIONS } from '@/directives/global/permission/permission.config'

export const baseInfo = {
  name: '有为工作',
  homePage: '/',
  companyName: '深圳志多薪大数据网络科技有限公司',
  type: PROJECT_NAME.ywWork,
  logo: require('../../assets/pageConfig/ywWork/logo.png'),
  copyright: '深圳志多薪大数据网络科技有限公司版权所有Copyright © 2018-2025 YOUZHIPAI.All Rights Reserved',
  beian: process.env.VUE_APP_COPYRIGHT_NO,
  isShowICP: false,
  icpNo: '',
  icpUrl: '',
  ossUrl: 'https://s.youweiwork.com',
  ossBucket: 'yxyr-web',
  GDKye: 'a81cf722d68e51c69677ea473a23a0d7',
  CSSTelephone: '0755-23480450',
  layoutNavData: [
    {
      name: '众包服务',
      path: '/payrollRecord/payrollRecord',
      type: 'crowdSourcingServices',
      permission: PERMISSIONS.crowdSourcingServices
    }
  ]
}
